
import React, { useState } from 'react';
import BannerImg from './04.png'
import { Link as ScrollLink } from "react-scroll";
import { Link } from 'react-router-dom';



const subTitle = "Welcome to Applying Hub";
const title = <h2 className="title"><span className="d-lg-block">Your Pathway to</span>  <span className="d-lg-block">Global Education</span></h2>;
const desc = "At Applying Hub, we empower students to achieve their dream of studying abroad. Our platform simplifies the application process, guiding you every step of the way—from choosing the right university to securing admissions with ease.";

const catagoryList = [
    {
        name: 'Figma',
        link: '#',
    },
    {
        name: 'Adobe XD',
        link: '#',
    },
    {
        name: 'illustration',
        link: '#',
    },
    {
        name: 'Photoshop',
        link: '#',
    },
]


const shapeList = [
    {
        name: '150+ Course',
        link: '#',
        className: 'ccl-shape shape-1',
    },
    {
        name: '10+ Countries',
        link: '#',
        className: 'ccl-shape shape-2',
    },
    {
        name: 'Fast Track Application',
        link: '#',
        className: 'ccl-shape shape-3',
    },
    {
        name: 'Visa Assistance',
        link: '#',
        className: 'ccl-shape shape-4',
    },
    {
        name: 'Scholarship opportunity',
        link: '#',
        className: 'ccl-shape shape-5',
    },
    {
        name: 'Pre-Post Departure Assistance',
        link: '#',
        className: 'ccl-shape shape-5',
    },
]

const Banner = () => {
    const [course, setcourse] = useState('');
    return (
        <section className="banner-section">
            <div className="container">
                <div className="section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-xxl-5 col-xl-6 col-lg-10">
                            <div className="banner-content">
                                <h6 className="subtitle text-uppercase fw-medium">{subTitle}</h6>
                                {title}
                                <p className="desc">{desc}</p>
                                {/* <ScrollLink to="student" smooth={true} duration={500}><button className='bg-[#0073E6] text-white'>apply Now</button></ScrollLink>
                                <ScrollLink to="contact" smooth={true} duration={500}><button className='text-black font-semibold'>Get Support </button></ScrollLink> */}
                                  <form action="/">
                                    <div className="banner-icon">
                                        <i className="icofont-search"></i>
                                    </div>
                                    <input type="text" value={course} onChange={(e)=>setcourse(e.target.value)} placeholder="Keywords of your course" />
                                    {course ? <button><Link to="/courses" className='text-white'>Search Course</Link></button> : <button>Search Course</button>}
                                    {/* <button type="submit">Search Course</button> */}
                                </form>
                                    
                                {/* <div className="banner-catagory d-flex flex-wrap">
                                    <p>Most Popular : </p>
                                    <ul className="lab-ul d-flex flex-wrap">
                                        {catagoryList.map((val, i) => (
                                            <li key={i}><a href={val.link}>{val.name}</a></li>
                                        ))}
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-xxl-7 col-xl-6">
                            <div className="banner-thumb">
                                <img src={BannerImg} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="all-shapes"></div>
            <div className="cbs-content-list d-none">
                <ul className="lab-ul">
                    {shapeList.map((val, i) => (
                        <li className={val.className} key={i}><a href={val.link}>{val.name}</a></li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
 
export default Banner;